import type { CtaItemDto } from '@/lib/sanity/dto';
import { BaseLink } from './BaseLink';

type CtaLinkProps = {
    item: CtaItemDto | null;
    className?: string;
    queryParams?: Record<string, string>;
};

export function CtaLink({ item, className, queryParams }: CtaLinkProps) {
    if (!item) return null;

    return <BaseLink item={item} className={className} queryParams={queryParams} />;
}
